import { useEffect } from 'react'

const STRUCTURED_DATA_ID_PREFIX = 'structured-data-'

// id ごとに <script type="application/ld+json"> を1つ管理する。
// data が null の場合は既存のタグを削除するだけで何も出力しない。
export const useStructuredData = (id: string, data: Record<string, unknown> | null): void => {
  const serialized = data !== null ? JSON.stringify(data) : null

  useEffect(() => {
    const elementId = `${STRUCTURED_DATA_ID_PREFIX}${id}`
    const existing = document.getElementById(elementId)
    if (existing !== null) {
      existing.remove()
    }

    if (serialized === null) {
      return
    }

    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.id = elementId
    script.textContent = serialized
    document.head.appendChild(script)

    return () => {
      script.remove()
    }
  }, [id, serialized])
}
